import GradesService from "@/services/GradesService";

export default {
    state() {
        return {
            grade: null,
            gradesData: "",
            gradesUrl: null
        }
    },

    getters: {
        getGrade: (state) => state.grade,
        getGradesData: (state) => state.gradesData,
        getGradesUrl: (state) => state.gradesUrl
    },

    mutations: {
        setGradeData(state, data) {
            state.grade = data;
        },
        setGradesData(state, data) {
            state.gradesData = data
        },
        setGradesUrl(state, data) {
            state.gradesUrl = data.url
        }
    },

    actions: {
        async getGrades({ commit, dispatch }, payload) {
            try {
                const response = await GradesService.getGrades(payload.data, payload.userToken);

                commit('setGradesData', response);

                return response;
            } catch (error) {
                console.error('Erro ao consultar notas', error);

                throw error;
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async updateGrade({ commit }, payload) {
            try {
                const response = await GradesService.updateGrade(payload, payload.userToken);

                commit('setGradeData', response);

                return response;
            } catch (error) {
                console.error('Erro ao atualizar nota', error);

                throw error;
            }
        },

        async exportGradesToCsv({ commit }, payload) {
            try {
                const response = await GradesService.exportGradesToCsv(payload.data, payload.userToken);

                commit('setGradesUrl', response);

                return response.url;
            } catch (error) {
                console.error('Erro ao exportar notas', error);

                throw error;
            }
        },
    }
}
